import { Grid } from '../../../../../Common/Grid'
import { TitleHeader } from '../../../../Common/TitleHeader'
import { URLS } from '../../../../constants'
import { useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import { makeCoreGetRequest } from '../../../../../../../utils/api'
import { formatErrorMessage } from '../../../../../../../utils/formatting'
import React, { useState } from 'react'
import { useNotification } from '../../../../../../../hooks'
import { CircularProgress, Paper } from "@mui/material"
import { Typography } from "@fullscreendigital/carrefour-dex-fe"

const InProgressReturns = () => {
  const navigate = useNavigate()
  const { showNotification } = useNotification()
  const [hasTrucks, setHasTrucks] = useState(false)

  const { data: truckList, isLoading } = useQuery(
    'inProgressTrucks',
    async () => {
      return await makeCoreGetRequest('/shop-reception-mobile/ds-return-truck/ds-return-truck-in-progress-list', null)
    },
    {
      onSuccess: data => {
        data.length > 0 ? setHasTrucks(true) : setHasTrucks(false)
      },
      onError: error => {
        showNotification({
          message: `Error while fetching trucks. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  if (isLoading) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
  }

  return (
    <Grid
      gridContainerStyle={{ marginTop: '20px' }}
      maxWidth="xs"
      items={[
        <TitleHeader title="Procesarea Recepției" />,
        hasTrucks ? (
          truckList.map((item: any) => (
            <Paper
              key={item.id}
              elevation={3}
              style={{ margin: '10px', padding: '20px' }}
              onClick={() => {
                navigate(URLS.AUTH_SUPPLIERS_RETURN_STEP_2, { state: { id: item.id, supplierCode: item.supplierCode } })
              }}
            >
              <Typography variant="medium" component="h5">
                {item.supplierName} {item.supplierCode}
              </Typography>
              <Typography variant="medium" component="p">
                {item.truckNumber} {item.driverName}
              </Typography>
              <Typography variant="medium" component="p">
                {item.truckStatus}
              </Typography>
            </Paper>
          ))
        ) : (
          <div style={{ textAlign: 'center' }}>Nu există camioane în lucru.</div>
        )
      ]}
      itemsPerRow={1}
    />
  )
}

export default InProgressReturns
